export default function limitLines(element, maxLines) {
    function countLines() {
        return element.getClientRects().length;
    }
    function checkLines() {
        const count = countLines();

        if (count && count > maxLines) {
            element.classList.add('long');
            element.setAttribute('title', element.innerHTML.replace(/<br>/g, ''));
        }
    }
    checkLines();
}
